import React, { PropsWithChildren } from 'react';

import { ButtonComponentProps, getButtonProps } from '../util/buttonProps';

import './LinkButton.css';

function LinkButton(props: PropsWithChildren<ButtonComponentProps>) {
  const { label, href, type, disabled, onClick } = props;
  const baseProps = getButtonProps(props, 'Link');

  return href && !disabled ? (
    <a {...baseProps} href={href}>
      {props.children || label}
    </a>
  ) : (
    <button
      {...baseProps}
      type={type}
      onClick={onClick}
      onKeyDown={onClick}
      disabled={disabled}
    >
      {props.children || label}
    </button>
  );
}

LinkButton.defaultProps = {
  id: '',
  className: '',
  label: '',
  href: '',
  type: 'button',
  disabled: false,
};

export default LinkButton;
